import { Component, OnInit, Injector, ViewChild, Injectable, ElementRef } from '@angular/core';
import { AlertService } from 'src/app/Common/alert.service';
import { UntypedFormGroup, FormArray, UntypedFormBuilder, Validators, NgForm } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { HTTPStatus } from 'src/app/Common/app-token-handler';
import { AppErrorHandler } from 'src/app/Common/app-error-handler';
import { DataService } from 'src/app/Common/data.service';
import { Global } from 'src/app/Global';
import * as XLSX from 'xlsx';
import { CommonService } from 'src/app/shared/common.service';
import saveAs from 'file-saver';

@Component({
  selector: 'app-category-master',
  templateUrl: './category-master.component.html',
  styleUrls: ['./category-master.component.scss'],
  providers: [DataService]
})
export class CategoryMasterComponent implements OnInit {
  CategoryMasterForm: UntypedFormGroup;
  roleList: any;
  selectedItems: [];
  dropdownSetting: {};
  dropdownList: [];
  viewdata: any;
  CategoryDataSource: any[];
  cols: any[];
  Ispanelshow: any;
  IsAddpanelshow: any;

  displayedColumns = ['CategoryName', 'EmployeeGPN', 'EmployeeName', 'Status', 'Edit'];
  ResumeDataSource: MatTableDataSource<any[]>;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  recordsExists: boolean = false;
  selectedDefault: any;
  @ViewChild('TABLE') table: ElementRef;
  public show: boolean = false;
  groupList: any;
  requesterList: any;
  filterList: any;
  statusList: any;



  constructor(private _fb: UntypedFormBuilder, private _router: Router, private error: AppErrorHandler,
    private _activeRoute: ActivatedRoute,
    injector: Injector, private _dialog: MatDialog,
    private status: HTTPStatus, public pcommonService: CommonService, public _dataservice: DataService, public _global: Global, public _com: CommonService) { }


  ngOnInit() {
    //this.paginator.showFirstLastButtons = true;
    this.Ispanelshow = false;
    this.IsAddpanelshow = false;
    //this.paginator.pageSize = this._global.RecordSize;
    this.CategoryMasterForm = this._fb.group({
      selectedroles: [[],],
      CategoryId: [''],
      EmployeeGPN: [''],
      CategoryName: ['',],
      AccessItemCode: [''],
      AccessItemDisplayName: [''],
      PageNumber: (this._global.pageIndex),
      PageSize: (this._global.RecordSize),
      IsActive: [''],
      AddCategoryName: ['', Validators.required],
      Category: ['', Validators.required],
      EmpName: ['', Validators.required],
      RequesterName: [''],
      RequesterGPN: [''],
      Id: [''],
      StatusSearch: [''],
      CustomerSearch: [''],
      EmpGPN: [''],

      //  Role: [, [Validators.required]]
    });
    //this.roleList = [ {name: 'New York', code: 'NY', inactive: false}, {name: 'Rome', code: 'RM', inactive: true}, {name: 'London', code: 'LDN', inactive: false}, {name: 'Istanbul', code: 'IST', inactive: true}, {name: 'Paris', code: 'PRS', inactive: false} ];
    this.BindCategoryList();
    this.SearchRecord();
    this.BindStatusList();

  }

  ngAfterViewInit() {
    if (this.paginator) {
      this.paginator.pageSize = this._global.RecordSize;
      this.paginator.showFirstLastButtons = true;
    }
  }

  BindCategoryList() {

    this.pcommonService.BindDropDown('CategoryWithRole').subscribe(result => {
      this.groupList = result;
    });
  }

  SearchRecord() {
    this._global.pageIndex = 0;
    this._global.length = 0;
    this._global.totalPage = 0;
    this._global.RecordSize = 10;
    this.ViewCategoryList();
  }

  toggle() {
    this.show = !this.show;
  }

  ViewCategoryList() {
    this.CategoryMasterForm.controls.PageNumber.setValue(this._global.pageIndex + 1);
    this.CategoryMasterForm.controls.PageSize.setValue(this._global.RecordSize);
    debugger;
    this.CategoryMasterForm.patchValue({
      EmpGPN: this.CategoryMasterForm.controls.CustomerSearch.value.EmployeeGPN,
      IsActive: this.CategoryMasterForm.controls.StatusSearch.value.StatusId,
    });
    this._dataservice.PostData('Category/GetCategoryList/', this.CategoryMasterForm.value).subscribe(result => {
      this.viewdata = result;
      if (this.viewdata != null && this.viewdata.length > 0) {
        this.CategoryDataSource = this.viewdata;
        this._global.length = this.viewdata[0].totalrecordcount;
        this._global.totalPage = Math.ceil(this._global.length / this.paginator.pageSize);
      } else {
        this.CategoryDataSource = this.viewdata;
        this._global.length = 0;
        this.paginator.pageSize = this._global.RecordSize;
        this._global.pageIndex = 0;
        this._global.totalPage = 0;
      }
    });
  }

  onPaginateChange1(event) {
    this._global.pageIndex = event.pageIndex;
    this._global.RecordSize = event.pageSize;
    this.ViewCategoryList();
  }

  Relod() {
    window.location.reload();
  }




  showErrorsOnInvalidForm() {
    Object.keys(this.CategoryMasterForm.controls).forEach(field => {
      const control = this.CategoryMasterForm.get(field);
      control.markAsTouched({ onlySelf: true });
    });
  }

  GetFormControls(controlName) {
    return this.CategoryMasterForm.controls[controlName];
  }



  Clear() {
    this.CategoryMasterForm.controls.AddCategoryName.setValue('');
    this.CategoryMasterForm.controls.Category.setValue('');
    this.CategoryMasterForm.controls.EmpName.setValue('');
    this.CategoryMasterForm.patchValue({
      Id: 0
    });
    this.GetFormControls('AddCategoryName').clearValidators();
    this.GetFormControls('Category').clearValidators();
    this.GetFormControls('EmpName').clearValidators();
    this.GetFormControls('AddCategoryName').updateValueAndValidity();
    this.GetFormControls('Category').updateValueAndValidity();
    this.GetFormControls('EmpName').updateValueAndValidity();
  }

  Export() {
    this.status.setHttpStatus(true);
    this._com.ExportData(this.CategoryMasterForm.value).subscribe(x => {
      const blob = new Blob([x], { type: 'application/octet-stream' });
      saveAs(blob, 'Category_Master.xls');
    }, (error) => {
      this.status.setHttpStatus(false);
      this.error.handleError(error);
    },
      () => { this.status.setHttpStatus(false); });
  }

  SearchActiveEmployee = (event) => {

    this.pcommonService.Autocomplete('FillCommonData/GetActiveEmployee', event.query).subscribe(result => {
      this.requesterList = this.filterDataList(event.query, result);

    }, (error) => {
      this.error.handleError(error);
    }, () => {
    });
  }
  filterDataList(query, dataList: any): any[] {
    const filtered: any[] = [];
    for (let i = 0; i < dataList.length; i++) {
      this.filterList = dataList[i];
      if (this.filterList.EmployeeName.toLowerCase().indexOf(query.toLowerCase()) === 0) {
        filtered.push(this.filterList);
      }
    }
    return filtered;
  }

  SetEmployeeDetails(event) {

    //ELEMENT_DATA.push({EmployeeGPN: event.EmployeeGPN, EmployeeName: event.EmpName, GroupName: this.AssigmentForm.controls.Group.value.GroupName, GroupId:this.AssigmentForm.controls.Group.value.GroupId})
    //this.AssigmentDataSource = new MatTableDataSource(ELEMENT_DATA);
    RequesterName: event.EmpName;
    RequesterGPN: event.EmployeeGPN;

  }



  clearAutoComplete(controlName) {

    this.CategoryMasterForm.controls.RequesterGPN.reset();
    this.CategoryMasterForm.controls.RequesterName.reset();
  }

  statusupdatedata(element) {
    if (confirm('Are you sure to want update status this record?')) {
      this.CategoryMasterForm.patchValue({
        CategoryId: 1,
        Id: element,
      });
      this.status.setHttpStatus(true);
      this._dataservice.PostData('Category/AddCategoryData/', this.CategoryMasterForm.value).subscribe(result => {
        alert(result[0].MSG);
        if (result[0].STATUS == 0) {
          this.Clear();
          this.SearchRecord();
        }
      }
        , (error) => {
          this.status.setHttpStatus(false);
          this.error.handleError(error);
        },
        () => { this.status.setHttpStatus(false); });
    }
  }

  addcategory() {
    this.GetFormControls('Category').clearValidators();
    this.GetFormControls('Category').updateValueAndValidity();
    this.GetFormControls('EmpName').clearValidators();
    this.GetFormControls('EmpName').updateValueAndValidity();
    this.GetFormControls('AddCategoryName').setValidators([Validators.required]);
    this.GetFormControls('AddCategoryName').updateValueAndValidity();
    if (!this.CategoryMasterForm.valid) {
      alert('Please fill Category Name');
      this.showErrorsOnInvalidForm();
      return false;
    }
    this.GetFormControls('Category').setValidators([Validators.required]);
    this.GetFormControls('Category').updateValueAndValidity();
    this.GetFormControls('EmpName').setValidators([Validators.required]);
    this.GetFormControls('EmpName').updateValueAndValidity();

    this.status.setHttpStatus(true);
    this._dataservice.PostData('Category/SaveCategoryName/', { 'AddCategoryName': this.CategoryMasterForm.controls.AddCategoryName.value }).subscribe(result => {
      alert(result[0].MSG);
      if (result[0].STATUS == 0) {
        this.CategoryMasterForm.controls.AddCategoryName.setValue('');
        this.toggle();
        this.Clear();
        this.BindCategoryList();
        this.GetFormControls('AddCategoryName').clearValidators();
        this.GetFormControls('AddCategoryName').updateValueAndValidity();

      }

    }
      , (error) => {
        this.status.setHttpStatus(false);
        this.error.handleError(error);
      },
      () => { this.status.setHttpStatus(false); });
  }


  Adddata() {
    this.GetFormControls('AddCategoryName').clearValidators();
    this.GetFormControls('AddCategoryName').updateValueAndValidity();
    this.GetFormControls('Category').setValidators([Validators.required]);
    this.GetFormControls('Category').updateValueAndValidity();
    this.GetFormControls('EmpName').setValidators([Validators.required]);
    this.GetFormControls('EmpName').updateValueAndValidity();

    if (!this.CategoryMasterForm.valid) {
      alert('Please fill mandatory fields.');
      this.showErrorsOnInvalidForm();

      return false;
    }
    this.GetFormControls('AddCategoryName').setValidators([Validators.required]);
    this.GetFormControls('AddCategoryName').updateValueAndValidity();

    this.status.setHttpStatus(true);
    this.CategoryMasterForm.patchValue({
      // Assigment:this.AssigmentForm.controls.Assigment.value.data,
      CategoryId: this.CategoryMasterForm.controls.Category.value.value,
      EmployeeGPN: this.CategoryMasterForm.controls.EmpName.value.EmployeeGPN,
    });
    this._dataservice.PostData('Category/AddCategoryData/', this.CategoryMasterForm.value).subscribe(result => {
      alert(result[0].MSG);
      if (result[0].STATUS == 0) {
        this.SearchRecord();
        this.Clear();
        this.GetFormControls('Category').clearValidators();
        this.GetFormControls('Category').updateValueAndValidity();
        this.GetFormControls('EmpName').clearValidators();
        this.GetFormControls('EmpName').updateValueAndValidity();
      }

    }
      , (error) => {
        this.status.setHttpStatus(false);
        this.error.handleError(error);
      },
      () => {
        this.status.setHttpStatus(false);
      });
  }

  clearAutoCompleteSearch(ControlName) {
    if (ControlName == 'CustomerSearch') {
      this.CategoryMasterForm.controls.CustomerSearch.reset();
    }
    else if (ControlName == 'StatusSearch') {
      this.CategoryMasterForm.controls.StatusSearch.reset();
    }
  }

  ResetData() {

    this.CategoryMasterForm.reset({
      "CustomerSearch": "",
      "StatusSearch": ""
    })
    this.GetResult();

  }

  Exit() {

    if (this.CategoryMasterForm.valid) {
      if (confirm("Are you sure you want to exit without saving changes?")) {
        //this.router.navigate(['dashboard']);
        window.history.back();
      }
    } else {
      if (confirm("Are you sure to exit?")) {
        //this.router.navigate(['dashboard']);
        window.history.back();
      }
    }

  }

  GetResult() {

    this.SearchRecord();


  }

  BindStatusList() {
    this._dataservice.GetData('Category/GetStatus/').subscribe(result => {

      this.statusList = result;
      debugger;
    });
  }

  showhide() {
    this.Ispanelshow = !this.Ispanelshow;

  }

  showhideAdd() {
    this.IsAddpanelshow = !this.IsAddpanelshow;

  }



}
